import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PostPayloadInterface} from '../models/post-payload.interface';
import {ApiUri, BaseApiUri, BaseRepository, HellpositoryConfig} from "hellpository";


@BaseApiUri('dashboard/staff')
@Injectable({
  providedIn: 'root'
})
export class NoteRepository extends BaseRepository<PostPayloadInterface> {

  constructor(public httpClient: HttpClient, public hellpConfig: HellpositoryConfig) {
    super(httpClient, hellpConfig);
  }

  @ApiUri('/{entity}/add-note')
  saveNote(entity: string, payload: PostPayloadInterface) {
    return super.post(payload);
  }
}
